document.addEventListener("DOMContentLoaded", () => {
  const carouselContainers = document.querySelectorAll(
    ".alternate-image-cards .embla"
  );

  carouselContainers.forEach((carouselContainer) => {
    const viewport = carouselContainer.querySelector(".embla__viewport");
    const dotsContainer = carouselContainer.querySelector(".embla__dots");
    const cardContainer = carouselContainer.closest(".image-card");
    const sectionContainer = carouselContainer.closest(
      ".alternate-image-cards"
    );

    const textCarouselContainer = cardContainer.querySelector(".embla-text");
    const textViewport = textCarouselContainer
      ? textCarouselContainer.querySelector(".embla__viewport")
      : null;
    const textDotsContainer = textCarouselContainer
      ? textCarouselContainer.querySelector(".embla__dots")
      : null;

    const enableAutoplay = sectionContainer.dataset.autoplay === "true";
    const autoplayDelay =
      parseFloat(sectionContainer.dataset.autoplayDelay || 4) * 1000;
    let autoplayInterval = null;

    const startAutoplay = (emblaApi) => {
      if (!enableAutoplay) return;

      stopAutoplay();
      autoplayInterval = setInterval(() => {
        if (emblaApi.canScrollNext()) {
          emblaApi.scrollNext();
        } else {
          emblaApi.scrollTo(0);
        }
      }, autoplayDelay);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    const initCarousel = () => {
      if (typeof EmblaCarousel === "undefined") {
        console.warn("EmblaCarousel is not loaded yet, retrying...");
        setTimeout(initCarousel, 100);
        return;
      }

      const emblaApi = EmblaCarousel(viewport, {
        draggable: true,
        slidesToScroll: 1,
        align: "start",
      });

      let emblaTextApi;
      if (textViewport) {
        emblaTextApi = EmblaCarousel(textViewport, {
          draggable: true,
          slidesToScroll: 1,
          align: "start",
        });

        emblaApi.on("select", () => {
          const index = emblaApi.selectedScrollSnap();
          if (emblaTextApi.selectedScrollSnap() !== index) {
            emblaTextApi.scrollTo(index);
          }
        });

        emblaTextApi.on("select", () => {
          const index = emblaTextApi.selectedScrollSnap();
          if (emblaApi.selectedScrollSnap() !== index) {
            emblaApi.scrollTo(index);
          }
        });
      }

      const createDots = () => {
        const slides = emblaApi.slideNodes();
        dotsContainer.innerHTML = "";
        if (textDotsContainer) textDotsContainer.innerHTML = "";

        slides.forEach((_, index) => {
          const dot = document.createElement("button");
          dot.classList.add("embla__dot");
          dot.setAttribute("type", "button");
          dot.setAttribute("aria-label", `Go to slide ${index + 1}`);

          dot.addEventListener("click", () => {
            emblaApi.scrollTo(index);

            if (enableAutoplay) {
              stopAutoplay();
              startAutoplay(emblaApi);
            }
          });

          dotsContainer.appendChild(dot);

          if (textDotsContainer) {
            const textDot = dot.cloneNode(true);
            textDot.addEventListener("click", () => {
              emblaApi.scrollTo(index);

              if (enableAutoplay) {
                stopAutoplay();
                startAutoplay(emblaApi);
              }
            });
            textDotsContainer.appendChild(textDot);
          }
        });

        updateDots();
      };

      const updateDots = () => {
        const selectedIndex = emblaApi.selectedScrollSnap();

        if (dotsContainer) {
          const dots = dotsContainer.querySelectorAll(".embla__dot");
          dots.forEach((dot, index) => {
            if (index === selectedIndex) {
              dot.classList.add("embla__dot--selected");
            } else {
              dot.classList.remove("embla__dot--selected");
            }
          });
        }

        if (textDotsContainer) {
          const textDots = textDotsContainer.querySelectorAll(".embla__dot");
          textDots.forEach((dot, index) => {
            if (index === selectedIndex) {
              dot.classList.add("embla__dot--selected");
            } else {
              dot.classList.remove("embla__dot--selected");
            }
          });
        }
      };

      const onSelect = () => {
        updateDots();
      };

      emblaApi.on("init", createDots);
      emblaApi.on("select", onSelect);
      emblaApi.on("reInit", createDots);

      emblaApi.on("pointerDown", stopAutoplay);
      emblaApi.on("pointerUp", () => {
        if (enableAutoplay) {
          startAutoplay(emblaApi);
        }
      });

      if (emblaTextApi) {
        emblaTextApi.on("pointerDown", stopAutoplay);
        emblaTextApi.on("pointerUp", () => {
          if (enableAutoplay) {
            startAutoplay(emblaApi);
          }
        });
      }

      if (enableAutoplay) {
        startAutoplay(emblaApi);
      }

      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          stopAutoplay();
        } else if (enableAutoplay) {
          startAutoplay(emblaApi);
        }
      });
    };

    setTimeout(initCarousel, 1000);
  });
});
